
import speed from './images/speed.svg';
import privacy from './images/privacy.svg';
import internet from './images/internet.svg';
import security from './images/security.svg';
import ecosystem from './images/ecosystem.svg';


const features = [{
  title: 'landing.skyware.features.speed.title',
  description: 'landing.skyware.features.speed.description',
  image: speed,
}, {
  title: 'landing.skyware.features.privacy.title',
  description: 'landing.skyware.features.privacy.description',
  image: privacy,
}, {
  title: 'landing.skyware.features.security.title',
  description: 'landing.skyware.features.security.description',
  image: security,
}, {
  title: 'landing.skyware.features.ecosystem.title',
  description: 'landing.skyware.features.ecosystem.description',
  image: ecosystem,
}, {
  title: 'landing.skyware.features.internet.title',
  description: 'landing.skyware.features.internet.description',
  image: internet,
}];

export default features;



// WEBPACK FOOTER //
// ./src/components/SkywireLanding/features.js